import Model from './Model'

export default class Afp extends Model
{
    static async all () {
        const { data } = await Http.get(route('api.v1.afps.due'))
        return this.make(data)
    }
}
